import { render } from "./Disc.vue?vue&type=template&id=68218864&scoped=true"
import script from "./Disc.vue?vue&type=script&lang=js"
export * from "./Disc.vue?vue&type=script&lang=js"

import "./Disc.vue?vue&type=style&index=0&id=68218864&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-68218864"

export default script